import React, { useEffect, useState } from "react";
import { 
	getEmployeeDetails
} from "../../../../redux/employee/employeeState";
import {  useDispatch, useSelector } from "react-redux";
import ProfileHeader from "components/card/ProfileHeader";


const EmployeeProfile = ({
	recordId,
}) => {
    const [employee, setEmployee] = useState(null);
    const dispatch = useDispatch();
    const recordData = useSelector((state) => state.employee.employeeDetails?.data);

    useEffect(() => {
        if (recordData) {
            setEmployee(recordData);
        }
    }, [recordData]);

    useEffect(() => {
        if (!recordData && recordId) {
            dispatch(getEmployeeDetails(recordId));
        }
    }, [dispatch, recordId]);
 
    return (
        <div className="gradient blue rounded-2xl shadow-md flex items-start gap-4">
            <ProfileHeader
                initials={recordData?.employee_initials}
                fullName={recordData?.user_detail?.full_name}
                designation={recordData?.emp_title}
                clientName={recordData?.client_name}
                employmentStatus={recordData?.employment_status_name}
                empCode={recordData?.emp_code}
            />
        </div>
    );
};

export default (EmployeeProfile);